// API Endpoints
const BASE_URL = process.env.VUE_APP_API_ENDPOINT;

export const endpoints = {
  // Authentication
  LOGIN: `${BASE_URL}/login/`,
  REFRESH_TOKEN: `${BASE_URL}/refresh-token`,
  ADMIN_LOGIN_TOKEN: `${BASE_URL}/admin-login-token`,

  // Users
  USERS: `${BASE_URL}/users/`,
  USER: `${BASE_URL}/user/`,

  // Companies
  COMPANIES: `${BASE_URL}/companies/`,

  // Cameras
  CAMERAS: `${BASE_URL}/cameras/`,
  CAMERA_SNAPSHOT_RESUME: `${BASE_URL}/camera/resume-snapshots`,
  CAMERA_DEVICE: (id) => `${BASE_URL}/cameras/${id}/device`,
  DEVICE_ALLOCATE: (id) => `${BASE_URL}/devices/${id}/allocate`,

  // Projects
  PROJECTS: `${BASE_URL}/projects/`,

  // Contracts
  CONTRACTS: `${BASE_URL}/contracts/`,
  CONTRACTS_LIST: `${BASE_URL}/contracts`,

  // Invoices
  INVOICES: `${BASE_URL}/invoices/`,
  INVOICES_LIST: `${BASE_URL}/invoices`,

  // Payments
  PAYMENTS: `${BASE_URL}/payments/`,
  PAYMENTS_LIST: `${BASE_URL}/payments`,

  // DZI
  DZI: `${BASE_URL}/dzi/`,

  // Dashboard
  DASHBOARD_STATS: `${BASE_URL}/dashboard/stats`,
  DASHBOARD_GROWTH_TRENDS: `${BASE_URL}/dashboard/growth-trends`,
  DASHBOARD_CAMERA_TYPES: `${BASE_URL}/dashboard/camera-types`,
  DASHBOARD_CAMERA_TYPE_TRENDS: `${BASE_URL}/dashboard/camera-type-trends`,
  DASHBOARD_REVENUE: `${BASE_URL}/dashboard/revenue`,
  DASHBOARD_PACKAGES: `${BASE_URL}/dashboard/packages`,
  DASHBOARD_FINANCIAL_STATS: `${BASE_URL}/dashboard/financial-stats`,

  // Activity Logs
  ACTIVITY_LOGS: `${BASE_URL}/activity-logs`,

  // Sent Emails
  SENT_EMAILS: `${BASE_URL}/sent-emails`,

  // Pro Camera Inventory
  PRO_CAMERA_INVENTORIES: `${BASE_URL}/pro-camera/inventories`,
  COMPONENTS: `${BASE_URL}/components`,
  COMPONENT_TYPES: `${BASE_URL}/components/types`,
};

export default endpoints;
